import { SxProps } from "@mui/material";

export const sxTextButton: SxProps = {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    border: 'none',
    borderRadius: 0,
    backgroundColor: 'transparent',
    color: 'var(--primary-blue)',
    textAlign: 'start',
    fontFamily: 'Montserrat-Regular',
    fontSize: 'var(--font-size-base)',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    cursor: 'pointer',
    maxWidth: 'fit-content',
    padding: '0px 12px',
    textTransform: 'none',
    height: 'fit-content',
    '&:hover': {
      opacity: 0.7
    },
    '@media (max-width: 1250px)': {
      fontSize: 'var(--font-size-small)'
    }
}
